// src/components/startPanelCopy.ts
//
// Every string on the empty bookshelf's start panel (#1124). The owner approves this copy
// word for word: change it only with them. House rules: no em dashes, Mac before Windows.

export const COPY = {
  computer: {
    headingMac: 'Get Chaptery on your Mac',
    headingWindows: 'Get Chaptery on your Windows PC',
    buttonMac: 'Download for Mac',
    buttonWindows: 'Download for Windows',
    busy: 'Preparing download…',
    otherFromMac: 'On Windows instead?',
    otherFromWindows: 'On a Mac instead?',
    allOptions: 'All download options',
    steps: [
      'Open the installer.',
      'Sign in the same way you signed up.',
      'Import your Word file or start a new book. It appears here once it syncs.',
    ],
    started: "Your download has started. Once it's installed, open Chaptery and sign in.",
    retry: "Didn't start? Try again",
  },
  away: {
    heading: "Chaptery's writing app runs on Mac and Windows",
    lede: "Get the download link by email, and install it when you're at your computer.",
    emailedLine: "We've emailed you a link to download it on your computer.",
    emailButton: 'Email me the download link',
    emailAgain: 'Email it again',
    sending: 'Sending…',
    sent: (address: string) => `We've sent the link to ${address}. Open it on your computer.`,
    dailyLimit: 'We sent the link in the last 24 hours. Check your inbox and spam folder.',
    alreadySent: "We've already sent the link to this address. Check your inbox and spam folder.",
    notSent: "We couldn't email this address. Use Send myself the link instead.",
    usesDesktop: 'You already use the desktop app. Your books appear here once they sync.',
    failed: "We couldn't send the email. Try again, or use Send myself the link.",
    share: 'Send myself the link',
    copied: 'Link copied',
    copyFailed: 'Copy failed',
    copyFallback: 'Copying was blocked here. The address is',
    shareTitle: 'Chaptery for desktop',
  },
  hero: {
    label: 'Welcome to Chaptery',
    altMac: "Chaptery's writing app on a Mac",
    altWindows: "Chaptery's writing app on Windows",
  },
  // Shown when the plan has lapsed with the page open; the same words as /downloads.
  noPlan: 'Choose a plan to download Chaptery.',
  seePlans: 'See plans',
} as const;
